import client from "../libs/HttpClient";

class GeneralsettingServices {
  static generalsettingList(request) {
    return client.get(`/get-setting-data`, request);
  }

  static updateStatusGeneralsetting(request) {
    return client.post(`/update-general-setting-data`, request);
  }
  
}
export { GeneralsettingServices };
